<div class = "signUpWrapper" *ngIf=" !isHandset; else mobileTemplate">
  <div id="main">
    <div class="flatWizard">
      <h4>
        <img src="../../assets/login-logo.png" height="275">
        <div class="step-title mt-3">Sign up for Research Arsenal</div>
      </h4>
      <h5 class="card-header">{{ showFinalBtn ? 'REGISTRATION COMPLETE!' : suSteps[currentStep].stepName }}</h5>
      <form #createAcctForm [formGroup]="suSteps[currentStep].stepFormGroup">
        <ng-container
          *ngTemplateOutlet="suSteps[currentStep].stepTemplate; context: {wrapperForm: suSteps[currentStep].stepFormGroup}">
        </ng-container>
      </form>
      <div class="loader-filters">
        <div *ngIf="waiting" class="loader-filters-inner ball-grid-pulse">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
    <br><br>
    <div id="paymentLegal" class="small text-muted text-center mb-1">
      By using this website, you agree to our <a href="../../assets/documents/Terms_and_Conditions.pdf" target="_blank"
        rel="noopener noreferrer">terms of service</a>.
    </div>
  </div>
    <app-site-footer></app-site-footer>
</div>

<ng-template #mobileTemplate>
  <div class = "mobile">
    <div id="main">
      <div class="flatWizard" >
        <h4>
          <img src="../../assets/login-logo.png" height="275">
          <div class="step-title mt-1" style="margin-top: 1rem!important; font-size: x-small;">Sign up for Research Arsenal</div>
        </h4>
        <h5 class="card-header">{{ showFinalBtn ? 'REGISTRATION COMPLETE!' : suSteps[currentStep].stepName }}</h5>
        <form #createAcctForm [formGroup]="suSteps[currentStep].stepFormGroup">
          <ng-container
            *ngTemplateOutlet="suSteps[currentStep].stepTemplate; context: {wrapperForm: suSteps[currentStep].stepFormGroup}">
          </ng-container>
        </form>
        <div class="loader-filters">
          <div *ngIf="waiting" class="loader-filters-inner ball-grid-pulse">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <br><br>
      <div id="paymentLegal" class="small text-muted text-center mb-1">
        By using this website, you agree to our <a href="../../assets/documents/Terms_and_Conditions.pdf" target="_blank"
          rel="noopener noreferrer">terms of service</a>.
      </div>
    </div>
    <app-site-footer [isHandset]="true"></app-site-footer>
  </div>
</ng-template>



<ng-template #suStep0 let-wrapperForm="wrapperForm">
  <div *ngIf="!captchaVerified" style="width: 100%; display: flex; justify-content: center;">
    <re-captcha (resolved)="resolvedRecaptcha($event)" [siteKey]="siteKey"></re-captcha>
  </div>
  <div *ngIf="captchaVerified">
    <div class="row">
      <div class="form-group" [ngClass]="{'col-5': !isHandset, 'col-9': isHandset}">
        <label for="lName" class="form-label">
          <i class="fal fa-lg fa-id-badge me-1"></i>
          Name
        </label>
        <input type="text" placeholder="Your first name" class="form-control editable" required
          [formControl]="wrapperForm['controls']['firstName']" name="fName" id="fName">
      </div>
    </div>
    <div class="row">
      <div class="form-group" [ngClass]="{'col-5': !isHandset, 'col-9': isHandset}">
        <input type="text" placeholder="Your last name" [formControl]="wrapperForm['controls']['lastName']" required
          minlength="2" class="form-control editable" id="lName" name="lName">
        <lib-form-error [control]="wrapperForm.controls['lastName']"></lib-form-error>
      </div>
    </div>
    <!-- <div class="row">
          <div class="form-group col-10">
              <label for="phone" class="form-label">
                  <i class="fal fa-phone me-1"></i>
                  Phone number <span class="small text-muted">(optional)</span>
              </label>
              <input type="tel" placeholder="(123) 456-7890" name="phone"
                  [formControl]="wrapperForm.controls['phoneNumber']" mask="(000) 000-0000" class="form-control editable">
          </div>
      </div>
      <label class="form-label mt-1">
          <i class="fal fa-birthday-cake me-1"></i>
          Birthday <span class="small text-muted">(optional)</span>
      </label>
      <div class="row">
          <div class="form-group col-4">
              <label for="birthMonth" class="form-label">
                  Month
              </label>
              <select name="birthMonth" id="birthMonth" class="form-control editable"
                  [formControl]="wrapperForm['controls']['birthMonth']">
                  <option *ngFor="let m of months" [value]="m.val">{{ m.txt }}</option>
              </select>
          </div>
          <div class="form-group col-2">
              <label for="birthDate" class="form-label" title="Enter 0 for unknown date">Date</label>
              <input type="number" min="0" max="31" name="birthDate" id="birthDate" title="Enter 0 for unknown date"
                  [formControl]="wrapperForm['controls']['birthDate']" class="form-control editable">
          </div>
          <div class="form-group col-2">
              <label for="birthYear" matTooltip="Year is optional. Enter 0 to skip.">Year</label>
              <input type="number" name="birthYear" id="birthYear" style="width: 92px;"
                  [formControl]="wrapperForm['controls']['birthYear']" title="Year is optional" min="0"
                  class="form-control editable" />
          </div>
      </div>
      <div class="row">
          <div class="form-group col-5 mb-2">
            <label for="username" class="form-label">Display name</label>
            <input type="text" placeholder="Your display name" [formControl]="wrapperForm.controls['userName']" matTooltip="You can change this later"
              class="form-control editable" required>
            <lib-form-error [control]="wrapperForm.controls['userName']"></lib-form-error>
          </div>
        </div> -->
    <div class="row">
      <div class="form-group" [ngClass]="{'col-5': !isHandset, 'col-9': isHandset}">
        <label for="userEmail" class="form-label" matTooltip="You cannot change this later">
          <i class="fal fa-lg fa-envelope me-1"></i>
          Email <span class="small text-muted" [style]="!isHandset? '': 'font-size: x-small;'">&mdash; you will use this to log in</span>
        </label>
        <input autocomplete="username" required matTooltip="You cannot change this later" type="email"
          placeholder="abc@xyz.com" class="form-control editable" [formControl]="wrapperForm.controls['email']"
          name="userEmail">
        <lib-form-error [control]="suSteps[0].stepFormGroup.controls.email"></lib-form-error>
        <div class="text-danger"
          *ngIf="(wrapperForm.controls['email'].dirty || wrapperForm.controls['email'].touched) && wrapperForm.controls['email'].errors?.emailAvailable">
          <small>Sorry, that email address is unavailable.
            <a href="javascript:void(0)" (click)="redirectToLogin(wrapperForm.controls['email'].value)" class="text-primary">
            Login instead?
            </a>
          </small>
        </div>
      </div>
    </div>
    <!--<div class="row">
      <div class="form-group col-5">
        <input required matTooltip="Confirm your email address" type="email" placeholder="Confirm your email address"
          class="form-control editable" [formControl]="wrapperForm['controls']['email2']" name="userEmail2">
        <lib-form-error [control]="wrapperForm['controls']['email2']"></lib-form-error>
      </div>
    </div>-->
    <div class="row">
      <div class="form-group" [ngClass]="{'col-5': !isHandset, 'col-9': isHandset}">
        <label for="pwd" class="form-label">
          <i class="fal fa-lg fa-key me-1"></i>
          Password
          <small>
            <a class="btn-sm btn-link infoLink" style="white-space: pre;" #pwdRules="matTooltip" [matTooltip]="passwordRulesText" matTooltipClass="tooltip-list"
              (click)="pwdRules.show()">Password rules</a>
          </small>
        </label>
        <div class="input-group">
          <input autocomplete="new-password" type="password" required [minlength]="appMinimumPwdLength" name="pwd"
            id="pwd" #pwd class="form-control editable" [formControl]="wrapperForm['controls']['password']"
            placeholder="A strong password">
          <div class="input-group-append">
            <button class="btn" tabindex="-1" (click)="pwd.type = pwd.type === 'password' ? 'text' : 'password'"
              type="button" id="showPwd-btn" matTooltip="Password visibility">
              <i class="fas" [ngClass]="pwd.type === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
        </div>
        <lib-form-error [control]="wrapperForm['controls']['password']"></lib-form-error>
        <div class="text-danger"
          *ngIf="(wrapperForm.controls['password'].dirty || wrapperForm.controls['password'].touched) && wrapperForm.controls['password'].errors?.passwordScore">
          <small>
            Password score too low. <br>
            (Score: {{ currentPwdScoreObj.currentScore }}; Required: {{ currentPwdScoreObj.minimumPwdScore }})
          </small>
        </div>
        <div class="text-danger"
          *ngIf="(wrapperForm.controls['password'].dirty || wrapperForm.controls['password'].touched) && wrapperForm.controls['password'].errors?.minlength">
          <small>Password too short. (Minimum length: {{ appMinimumPwdLength }})</small>
        </div>
      </div>
    </div>
    <!--<div class="row">
      <div class="form-group col-5">
        <input autocomplete="new-password" type="password" required [minlength]="appMinimumPwdLength" name="pwd2"
          id="pwd2" placeholder="Re-type your password" class="form-control editable"
          [formControl]="wrapperForm['controls']['confirmPassword']">
        <div class="text-danger"
          *ngIf="(wrapperForm.controls['confirmPassword'].dirty || wrapperForm.controls['confirmPassword'].touched) && wrapperForm.errors?.unequal">
          <small>Fields must match.</small>
        </div>
      </div>
    </div>-->
    <div id="step1Buttons" class="btn-group col-11">
      <app-slant-button [linkMode]="true" [disabled]="waiting" (click)="cancelSignup()">
        Cancel
      </app-slant-button>
      <app-slant-button [linkMode]="true" [submitMode]="true" [disabled]="wrapperForm.invalid || waiting"
        (click)="signUpNewUser(outputObject)">
        Next
        <i class="fal fa-angle-right ms-1"></i>
      </app-slant-button>
    </div>
  </div>
</ng-template>

<ng-template #suStep1>
  <app-plan-choices [subUserAcct]="outputObject" [signupMode]="true" [isHandset] = "isHandset"
    [topText]="'Subscribe now to see detailed image data or try us out with the free plan!'"
    [devOrTestingMode]="devOrTestingMode" (subscriptionCancelEvent)="gotoFirstStep()"
    (openPaymentFormEvent)="openPaymentForm($event)">
  </app-plan-choices>
</ng-template>

<ng-template #suStep2 >
  <div class="row">
    <div class="text-center" [ngClass]="{'col-4': !isHandset, 'col-12': isHandset}" [collapse]="showFinalBtn">
      <app-slant-button [linkMode]="true" (click)="chosenPlan = undefined; gotoPlanSelection()">
        <i class="fal fa-chevron-circle-left me-1"></i>Choose a different plan
      </app-slant-button>
      <br>
      <img class="planImg" [src]="chosenPlan.altFilePath">
    </div>
    <div class="col">
      <div *ngIf="chosenPlan.price === 0">
        <h5>
          {{ chosenPlan.description }}
        </h5>
        You won't be billed unless you choose to subscribe.
        <br>
        <app-slant-button *ngIf="!showFinalBtn" [linkMode]="true" [submitMode]="true" (click)="finallyDone()">
          Next
          <i class="fal fa-angle-right ms-1"></i>
        </app-slant-button>
      </div>
      <app-fortis-payment-form *ngIf="chosenPlan.price > 0" [chosenPlan]="chosenPlan" [signupMode]="true" [isHandset]="isHandset"
        [userAccount]="outputObject" (successfullySubscribed)="finallyDone()">
      </app-fortis-payment-form>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col text-center" *ngIf="showFinalBtn">
      <hr>
      <p>
        Check your email for a confirmation message from <strong>{{ emailFrom }}</strong> and click the link to activate
        your account.
      </p>
      <p style="font-size: 1.25em;">
        <i class="fas fa-info-circle text-info me-1"></i>
        <em style="background-color: yellow;">You must click the link in your email before you can use the system.</em>
      </p>
      <p>
        Please add <strong>{{ emailFrom }}</strong> to your contacts to help prevent messages from going to spam.
      </p>
      <p class="blueText">
        Research Arsenal's collection includes <strong>over 100,000</strong> documents and images with more being
        added daily. Search or browse through our records including photographs, letters &amp; diaries,
        ordnance returns and much more.
      </p>
      <app-slant-button [btnColor]="'green'" [btnIconClass]="'fa-sign-in fa-lg'" [chevronMode]="true"
        (click)="gotoLoginScreen()" [tooltip]="'Click here after you have checked your email'">
        Log In
      </app-slant-button>
    </div>
  </div>
</ng-template>
